import Vue from "vue";
import i18n from "@/i18n";
import VueRouter from "vue-router";
import * as KEYS from "./routerKeys";
import { session } from "@/utils/storage";
import { PAGE_PATH } from "@/utils/storageKey";
import { setWebAppCacheData } from "@/utils/cache";
import { PAGE_NAV_LIST } from "@/utils/cacheKey";
import message from "../utils/message";
import LoadingManager from "@/utils/LoadingManager";
import ServiceSDKModule from "@gtt/service-sdk";
import { getWebAppCacheData } from "@/utils/cache";
import * as cacheKey from "@/utils/cacheKey";
const PageType = ServiceSDKModule.tech.gtt.frontapp.servicesdk.interfaces.service.meta.node.PageNode.PageType;
Vue.use(VueRouter);

// 处理同一页面的重复导航报错问题
const originalPush = VueRouter.prototype.push;

VueRouter.prototype.push = function push(location) {
  return (originalPush.call(this, location) as any).catch((err: any) => err);
};

let pageNavList = [] as any[];
let accountNavList: any;
let accountRoutes: any;
export function accountDiffRoutes() {
  if (getWebAppCacheData(cacheKey.IS_NOVA_TEMPLATE)) {
    accountRoutes = {
      path: "/my",
      name: KEYS.MY,
      component: () => import("../views/profile/index.vue"),
      children: [
        {
          path: "account",
          name: KEYS.ACCOUNT,
          component: () => import("../views/profile/novaTemplateComponents/Account.vue"),
        },
      ],
    };
    accountNavList = {
      hasChildren: true,
      pathName: KEYS.ACCOUNT,
      children: [
        {
          title: i18n.t("myAccount"),
          icon: "profile_icon",
          pathName: KEYS.ACCOUNT,
          path: "/my/account",
        },
        {
          title: i18n.t("logout"),
          pathName: KEYS.LOGOUT,
          icon: "logout_icon",
        },
      ],
    };
  } else {
    accountRoutes = {
      path: "/my",
      name: KEYS.MY,
      component: () => import("../views/profile/index.vue"),
      children: [
        {
          path: "account",
          name: KEYS.ACCOUNT,
          component: () => import("../views/profile/classicTemplateComponents/Account.vue"),
        },
        {
          path: "plan",
          name: KEYS.PLAN,
          component: () => import("../views/profile/classicTemplateComponents/Plan.vue"),
        },
        {
          path: "subscribe",
          name: KEYS.SUBSCRIBE,
          component: () => import("../views/profile/classicTemplateComponents/Subscribe.vue"),
        },
      ],
    };
    accountNavList = {
      hasChildren: true,
      pathName: KEYS.ACCOUNT,
      children: [
        {
          title: i18n.t("myAccount"),
          icon: "profile_icon",
          pathName: KEYS.ACCOUNT,
          path: "/my/account",
        },
        {
          title: i18n.t("myPackage"),
          path: "/my/plan",
          pathName: KEYS.PLAN,
          icon: "plan_icon",
        },
        {
          title: i18n.t("subscribe"),
          path: "/my/subscribe",
          pathName: KEYS.SUBSCRIBE,
          icon: "subscribe_icon",
        },
        {
          title: i18n.t("logout"),
          pathName: KEYS.LOGOUT,
          icon: "logout_icon",
        },
      ],
    };
  }
  // 添加动态路由
  router.addRoute(KEYS.LAYOUT, accountRoutes);
}

export { accountNavList };

const routes: any = [
  {
    path: "/",
    name: KEYS.LAYOUT,
    redirect: "/home",
    component: () => import("../layout/layoutBox.vue"),
    children: [
      {
        path: "/home",
        name: KEYS.HOME,
        component: () => import("../views/home/index.vue"),
      },
      {
        path: "/liveTv",
        name: KEYS.LIVE_TV,
        component: () => import("../views/liveTv/index.vue"),
      },
      {
        path: "/metaList/:title",
        name: KEYS.META_LIST,
        component: () => import("../views/metaList/index.vue"),
      },
      {
        path: "/meta/detail/:id",
        name: KEYS.META_DETAIL,
        component: () => import("../views/metaDetail/index.vue"),
      },
      {
        path: "/search",
        name: KEYS.SEARCH,
        component: () => import("../views/search/index.vue"),
      },
      {
        path: "/filter",
        name: KEYS.FILTER,
        component: () => import("../views/filter/index.vue"),
      },
    ],
  },
  {
    path: "/welcome",
    name: KEYS.WELCOME,
    component: () => import("../views/welcome/index.vue"),
  },
  {
    path: "/login",
    name: KEYS.LOGIN,
    component: () => import("../views/login/index.vue"),
  },
  {
    path: "*",
    redirect: "/",
  },
];

// 初始化页面导航栏，用于确定home页面使用的组件
export async function initHeaderMenuList(sdkContent: any) {
  LoadingManager.showLoading();
  pageNavList = [];
  try {
    const layoutTreeStructure = (await new Promise((resolve, reject) => {
      sdkContent.getMetaService().queryLayoutTreeStructure().proceedWithCallback({
        onSuccess: resolve,
        onFail: reject,
      });
    })) as any;
    // 页面列表在pages，层级依次为Page - categoryGroups - Category - List - Item
    layoutTreeStructure.pages.asJsArrayView().forEach((pageItem: any) => {
      if (pageItem.pageType === PageType.LIVE_TV) {
        pageNavList.push({
          title: pageItem.name,
          navIndex: KEYS.LIVE_TV + pageItem.name, // 用于区分tab
          path: "/liveTv",
          pathName: KEYS.LIVE_TV, // 用于跳转页面
          hasChildren: false,
        });
      } else if (pageItem.pageType === PageType.META_PAGE) {
        // const currentCategoryGroup = pageItem.categoryGroups
        //   .asJsArrayView()
        //   .find(
        //     (categoryGroup: any) =>
        //       categoryGroup.categories.asJsArrayView().length
        //   );
        // const categories = currentCategoryGroup.categories.asJsArrayView();
        const categoryGroups = pageItem.categoryGroups.asJsArrayView();
        if (!categoryGroups?.length) return;
        // 如果categories数量为1，则隐藏子级。否则显示子级
        pageNavList.push({
          title: pageItem.name,
          navIndex: KEYS.META_LIST + pageItem.name,
          pathName: KEYS.META_LIST,
          pageId: pageItem.nodeId,
          hasChildren: categoryGroups.length > 1,
          children: categoryGroups.map((groupItem: any) => {
            return {
              title: groupItem.name,
              navIndex: KEYS.META_LIST + pageItem.name + groupItem.name,
              path: `/metaList/${groupItem.name}`,
              pathName: KEYS.META_LIST,
              categories:
                groupItem.categories.asJsArrayView().map((category: any) => {
                  return {
                    title: category.name,
                    lists: category.lists.asJsArrayView(),
                    categoryType: category.categoryType,
                    path: `/metaList/${groupItem.name}`,
                    nodeId: category.nodeId,
                    ageRating: category.ageRating || null,
                  };
                }) || [],
              groupId: groupItem.nodeId,
              query: {
                pageId: pageItem.nodeId,
                categoryGroupId: groupItem.nodeId,
                categoryId: groupItem.categories.asJsArrayView()[0]?.nodeId, // 默认选中第一个category
              },
            };
          }),
        });
      }
    });
    console.log(pageNavList);
    setWebAppCacheData(PAGE_NAV_LIST, pageNavList);
    LoadingManager.hideLoading();
  } catch (exception: any) {
    setWebAppCacheData(PAGE_NAV_LIST, []);
    LoadingManager.hideLoading();
    message.error(exception?.message || "Unknown error");
  }
}

const router = new VueRouter({
  mode: "history",
  routes,
});

// 等待SDK初始化的辅助函数
function waitForSDKInitialization(serviceSDK: any, maxWaitTime = 30000): Promise<boolean> {
  return new Promise((resolve, reject) => {
    // 如果SDK已经初始化完成，直接返回
    if (serviceSDK && serviceSDK.sdkStatus === "initialized" && serviceSDK.sdkContent) {
      resolve(true);
      return;
    }

    // 如果SDK初始化失败，直接返回
    if (serviceSDK && serviceSDK.sdkStatus === "error") {
      reject(new Error("SDK initialization failed"));
      return;
    }

    // 如果SDK还在初始化中，等待它完成
    const startTime = Date.now();
    const checkInterval = setInterval(() => {
      if (serviceSDK && serviceSDK.sdkStatus === "initialized" && serviceSDK.sdkContent) {
        clearInterval(checkInterval);
        resolve(true);
      } else if (serviceSDK && serviceSDK.sdkStatus === "error") {
        clearInterval(checkInterval);
        reject(new Error("SDK initialization failed"));
      } else if (Date.now() - startTime > maxWaitTime) {
        // 超时，停止等待
        clearInterval(checkInterval);
        reject(new Error("SDK initialization timeout"));
      }
    }, 100);
  });
}

router.beforeEach(async (to, from, next) => {
  if (document.pictureInPictureElement) {
    // 画中画模式下需要新开页面
    const newRouteUrl = router.resolve({
      path: to.path,
      params: to?.params,
      query: to?.query,
    });
    window.open(newRouteUrl.href, "_blank");
    return;
  }

  try {
    const app: any = router.app as any;
    // App 根组件实例通常为 $children[0]
    const appComponent = app && app.$children && app.$children[0];
    const serviceSDK = appComponent && appComponent.serviceSDK;

    // 登录状态校验
    if (!serviceSDK || !serviceSDK.sdkContent) {
      // SDK 尚未就绪，标记未登录，放行
      if (serviceSDK) {
        serviceSDK.loginStatus = false;
      }
      return next();
    }

    const statusResp = await serviceSDK.sdkContent
      .getAccountService()
      .isLoggedIn();
    serviceSDK.loginStatus = statusResp;
    if (!statusResp) {
      serviceSDK.loginStatus = false;
      serviceSDK.authRequired = true;
      if (to.name !== KEYS.LOGIN) {
        return next({ name: KEYS.LOGIN });
      }
    }

    // 已登录，允许访问
    return next();
  } catch (error) {
    console.error("路由守卫错误:", error);
    return next({ name: KEYS.LOGIN });
  }
});

// router.beforeEach(async (to, from, next) => {
//   console.log("beforeEach to:", to);
//   console.log("beforeEach from:", from);
//   if (document.pictureInPictureElement) {
//     // 画中画模式下需要新开页面
//     const newRouteUrl = router.resolve({
//       path: to.path,
//       params: to?.params,
//       query: to?.query,
//     });
//     window.open(newRouteUrl.href, "_blank");
//     return;
//   }

//   try {
//     const app: any = router.app as any;
//     // App 根组件实例通常为 $children[0]
//     const appComponent = app && app.$children && app.$children[0];
//     const serviceSDK = appComponent && appComponent.serviceSDK;
//     // 等待SDK初始化完成
//     waitForSDKInitialization(serviceSDK).then(async (sdkReady) => {
//       console.log("waitForSDKInitialization", serviceSDK);
//       if (!sdkReady || !serviceSDK.sdkContent) {
//         // SDK初始化失败或超时，重定向到登录页
//         serviceSDK.loginStatus = false;
//         serviceSDK.authRequired = true;
//         if (to.name !== KEYS.LOGIN) {
//           return next({ name: KEYS.LOGIN });
//         }
//       }
//       // SDK已初始化完成，检查登录状态
//       const statusResp = await serviceSDK.sdkContent.getAccountService().isLoggedIn();
//       serviceSDK.loginStatus = statusResp;
//       console.log("statusResp", statusResp);

//       // 如果未登录，重定向到登录页
//       if (!statusResp) {
//         serviceSDK.loginStatus = false;
//         serviceSDK.authRequired = true;
//         if (!from.name) {
//           message.error(i18n.t("loginRequired"));
//         }
//         // 如果当前页面是登录页，则不重定向
//         if (to.name !== KEYS.LOGIN) {
//           // 保存当前要访问的路由，登录后可以跳转回来
//           return next({
//             name: KEYS.LOGIN,
//             query: { redirect: to.fullPath },
//           });
//         }
//       }
//     });

//     // 已登录，允许访问
//     return next();
//   } catch (error) {
//     return next({ name: KEYS.LOGIN });
//   }
// });

router.afterEach((to: any, from: any) => {
  // 只有当路由的路径部分（?之前）发生变化时才回到顶部
  // 如果只是查询参数变化（?后面的参数），保持滚动位置
  if (to.path !== from.path) {
    (document.getElementById("app") as any).scrollTop = 0;
  }
  // 记录页面路由用于数据上报
  if (to.meta?.id) {
    let pagePath = session.get(PAGE_PATH) as any;
    pagePath = pagePath ? JSON.parse(pagePath) : [];
    const pageItem = {
      id: to?.meta?.id,
      index: pagePath.length,
      name: to?.name,
    };
    pagePath.push(pageItem);
    session.set(PAGE_PATH, JSON.stringify(pagePath));
  }
});

// 跳转直播页面时更新livePlaySource
export function goToLive(logicalChannelId: any, columnId: any) {
  // 记录播放来源
  const ROUTER_NAME = (router.app as any)._route.name;
  router.push({
    name: KEYS.LIVE_TV,
    params: {
      id: logicalChannelId,
      columnId,
    },
  });
}

export default router;
